/**
 * GalleryErrorState — error state for /gallery (design-audit-fixes).
 *
 * Props:
 *  - onRetry (fn) — клик по кнопке «Попробовать снова»
 */
import { useTranslation } from 'react-i18next';
import { Icon } from '../primitives';
import { UIButton } from '../primitives';

export default function GalleryErrorState({ onRetry }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-col items-center justify-center flex-1 px-body-x py-12 gap-6"
      data-testid="gallery-error-state"
    >
      <Icon name="alert" size={48} className="text-text-secondary" />
      <p className="font-sans text-plan text-text-secondary text-center">
        {t('gallery.loadError')}
      </p>
      <UIButton
        type="primary"
        size="md"
        onClick={onRetry}
        className="w-full max-w-xs"
        data-testid="gallery-error-retry"
        aria-label={t('common.retry')}
      >
        {t('common.retry')}
      </UIButton>
    </div>
  );
}
